import { render, staticRenderFns } from "./teshulist.vue?vue&type=template&id=464dac37&scoped=true&"
import script from "./teshulist.vue?vue&type=script&lang=js&"
export * from "./teshulist.vue?vue&type=script&lang=js&"
import style0 from "./teshulist.vue?vue&type=style&index=0&id=464dac37&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "464dac37",
  null
  
)

export default component.exports